import React from "react";

const Burger = (props) => {
  return (
    <div className="burger dn" onClick={() => props.clickCallback()}>
      <div className="lines line-1"> </div>
      <div className="lines line-2"> </div>
      <div className="lines line-3"> </div>
    </div>
  );
};

export default Burger;
